import React, { FC } from "react";

interface IProps {
  description: string;
  data: object[];
  isLoading: boolean;
  children: JSX.Element;
}

const EmptyLayout: FC<IProps> = (props) => {
  return props.isLoading || props.data.length ? (
    props.children
  ) : (
    <div
      className="d-flex justify-content-center align-items-center gap-3 flex-column"
      style={{ minHeight: 330 }}
    >
      <img
        src="/imgs/cart/empty-cart.svg"
        className="h-200 mb-3"
        alt="دیتایی وجود ندارد."
      />
      <p className="mb-0 fw-bold">{props.description}</p>
    </div>
  );
};

export default EmptyLayout;
